<template>
    <div>
        <vx-card title="Trainings" subtitle="Lists of Trainings"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewTrainings()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeTrainings">
                    <template slot="thead">
                        <vs-th>Training Name</vs-th>
                        <vs-th>Training School</vs-th>
                        <vs-th>Trainor</vs-th>
                        <vs-th>Start Date</vs-th>
                        <vs-th>End Date</vs-th>
                        <vs-th>With Cert?</vs-th>
                        <vs-th>Credential Id</vs-th>
                        <vs-th>Credential URL</vs-th>
                        <vs-th>Date Issue</vs-th>
                        <vs-th>Date Expired</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].trainingName">
                                {{ data[indextr].trainingName }}
                            </vs-td>
                            <vs-td :data="data[indextr].trainingSchoolName">
                                {{ data[indextr].trainingSchoolName }}
                            </vs-td>
                            <vs-td :data="data[indextr].trainorName">
                                {{ data[indextr].trainorName }}
                            </vs-td>
                            <vs-td :data="data[indextr].trainingStartDate">
                                {{data[indextr].trainingStartDate | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].trainingEndDate">
                                {{data[indextr].trainingEndDate  | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].isWithCertificate">
                                {{data[indextr].isWithCertificate}}
                            </vs-td>
                            <vs-td :data="data[indextr].credentialId">
                                {{ data[indextr].credentialId }}
                            </vs-td>
                            <vs-td :data="data[indextr].credentialURL">
                                {{ data[indextr].credentialURL }}
                            </vs-td>
                            <vs-td :data="data[indextr].dateIssued">
                                {{ data[indextr].dateIssued  | fulldate  }}
                            </vs-td>
                            <vs-td :data="data[indextr].dateExpire">
                                {{ data[indextr].dateExpire  | fulldate  }}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD TRAININGS -->
            <vs-prompt
                class="email-compose"
                title="Trainings"
                accept-text= "Submit"
                @accept="onAddTrainings"
                :is-valid="validForm"
                :active.sync="activePromptNewTrainings">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Training Name</span><span style="color:red">*</span>
                        <vs-input name="trainingName-name" class="w-full" v-model="trainingName" placeholder="Name of Training/Seminar" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Training School</span><span style="color:red">*</span>
                         <vs-input name="trainingSchoolName" class="w-full" v-model="trainingSchoolName" placeholder="Training School Name"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Trainor</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="trainor name" class="w-full" v-model="trainorName"  placeholder="Trainor" />
                        <span class="text-danger text-sm" v-show="errors.has('trainor name')">{{ errors.first('trainor name') }}</span>
                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span><span style="color:red">*</span>
                       <datepicker name="trainingStartDate-name" class="w-full" v-model="trainingStartDate" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span><span style="color:red">*</span>
                        <datepicker name="trainingEndDate-name" class="w-full" v-model="trainingEndDate" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm"></span>
                        <vs-checkbox name="isWithCertificate-name"  v-model="isWithCertificate" class="pointer-events-none"> With Certification?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Credential Id</span>
                        <vs-input name="credentialId-name" class="w-full" v-model="credentialId" placeholder="Credential Id"/>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Credential URL</span>
                        <vs-input name="credentialURL-name" class="w-full" v-model="credentialURL"  placeholder="URL"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Issued</span><span style="color:red">*</span>
                       <datepicker name="dateIssued-name" class="w-full" v-model="dateIssued" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Expire</span>
                        <datepicker name="dateExpire-name" class="w-full" v-model="dateExpire" placeholder="Select Date" />
                        
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT TRAININGS -->
            <vs-prompt
                class="email-compose"
                title="Edit Trainings"
                accept-text= "Submit"
                @accept="onEditTrainings"
                :is-valid="validForm"
                :active.sync="activePromptEditTrainings">
                <vx-card title="You may update the following information">


             <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Training Name</span><span style="color:red">*</span>
                        <vs-input name="trainingName-name" class="w-full" v-model="trainingName" placeholder="Name of Training/Seminar" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Training School</span><span style="color:red">*</span>
                         <vs-input name="trainingSchoolName" class="w-full" v-model="trainingSchoolName" placeholder="Training School Name"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Trainor</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="trainor name" class="w-full" v-model="trainorName"  placeholder="Trainor" />
                        <span class="text-danger text-sm" v-show="errors.has('trainor name')">{{ errors.first('trainor name') }}</span>

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span><span style="color:red">*</span>
                       <datepicker name="trainingStartDate-name" class="w-full" v-model="trainingStartDate" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span><span style="color:red">*</span>
                        <datepicker name="trainingEndDate-name" class="w-full" v-model="trainingEndDate" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm"></span>
                        <vs-checkbox name="isWithCertificate-name"  v-model="isWithCertificate" disabled="true" > With Certification?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Credential Id</span>
                        <vs-input name="credentialId-name" class="w-full" v-model="credentialId" placeholder="Credential Id"/>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Credential URL</span>
                        <vs-input name="credentialURL-name" class="w-full" v-model="credentialURL"  placeholder="URL"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Issued</span><span style="color:red">*</span>
                       <datepicker name="dateIssued-name" class="w-full" v-model="dateIssued" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Expire</span>
                        <datepicker name="dateExpire-name" class="w-full" v-model="dateExpire" placeholder="Select Date" />
                        
                    </div>
                </div>
                 
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            trainingName        : '',
            trainorName         : '',
            trainingSchoolName  : '',
            isWithCertificate   : true,
            trainingStartDate   : null,
            trainingEndDate     : null,
            credentialId        : '',
            credentialURL       : '',
            dateIssued          : null,
            dateExpire          : null,
            userId              : null,

            uid                 : null,
            activePromptNewTrainings    : false,
            activePromptEditTrainings    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.uid = this.$route.params.id
            this.employeeTrainings = this.uid
            
    },
    computed: {
        employeeTrainings: {
           
           get() { return this.$store.state.hrms.employeeTraining },
           set(value) { this.$store.dispatch('hrms/getAllTraining',  value )}
            
        },
        validForm(){
            return this.trainingName != '' && this.trainingSchoolName != '' && this.trainorName &&
            this.trainingStartDate !=null && this.trainingEndDate != null &&
            this.dateIssued != null
        },
       
       
    },
    methods: {
        promptAddNewTrainings() {
            this.activePromptNewTrainings = true
        },
        onAddTrainings() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    trainingName         : this.trainingName,
                    trainingSchoolName   : this.trainingSchoolName,
                    trainorName          : this.trainorName,
                    trainingStartDate    : this.trainingStartDate,
                    trainingEndDate      : this.trainingEndDate,
                    isWithCertificate    : this.isWithCertificate,
                    credentialId         : this.credentialId,
                    credentialURL        : this.credentialURL,
                    dateIssued           : this.dateIssued,
                    dateExpire           : this.dateExpire,
                    userId               : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
    //console.log(data)
                this.$store.dispatch('hrms/AddTraining', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Trainings Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        onEditTrainings() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                   : this.id,
                    trainingName         : this.trainingName,
                    trainingSchoolName   : this.trainingSchoolName,
                    trainorName          : this.trainorName,
                    trainingStartDate    : this.trainingStartDate,
                    trainingEndDate      : this.trainingEndDate,
                    isWithCertificate    : this.isWithCertificate,
                    credentialId         : this.credentialId,
                    credentialURL        : this.credentialURL,
                    dateIssued           : this.dateIssued,
                    dateExpire           : this.dateExpire,
                    userId               : this.uid,
                    currentUserId        : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateTraining', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Trainings Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {
            
            const e = this.$store.getters['hrms/employeeTraining'](Id)
            this.id             = e.id,
            this.trainingName         = e.trainingName,
            this.trainingSchoolName   = e.trainingSchoolName,
            this.trainorName          = e.trainorName,
            this.trainingStartDate    = e.trainingStartDate,
            this.trainingEndDate      = e.trainingEndDate,
            this.isWithCertificate    = e.isWithCertificate,
            this.credentialId         = e.credentialId,
            this.credentialURL        = e.credentialURL,
            this.dateIssued           = e.dateIssued,
            this.dateExpire           = e.dateExpire,
            this.userId               = e.userId

            this.activePromptEditTrainings = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteTraining', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeTrainings = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Trainings Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>